import { useEffect } from 'react'
import { config } from '@/config/env'

export const useDebugInfo = () => {
  useEffect(() => {
    if (config.isDevelopment) {
      console.log('SLYRSA - modo desarrollo')
      console.log('API:', config.apiBaseUrl)
    }
  }, [])
}
